import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { browserHistory, Route, Router } from 'react-router';
import My404Component from './components/404/My404Component';
import SignOutPage from './components/SignOut/SignOutPage';
import { detectBrowserLocale } from './constants';
import App from './containers/App';
import BrowseIdeasContainer from './containers/BrowseIdeasContainer';
import CipGroupsContainer from './containers/CipGroupsContainer';
import EditCipGroupContainer from './containers/EditCipGroupContainer';
import ErrorContainer from './containers/ErrorContainer';
import HomeContainer from './containers/HomeContainer';
import IdeaContainer from './containers/IdeaContainer';
import InitiativeTypesContainer from './containers/InitiativeTypesContainer';
import IntlContainer from './containers/IntlContainer';
import MyIdeasContainer from './containers/MyIdeasContainer';
import ProcessCIPContainer from './containers/ProcessCIPContainer';
import ProcessInitiativeContainer from './containers/ProcessInitiativeContainer';
import UserEditContainer from './containers/UserEditContainer';
import UsersContainer from './containers/UsersContainer';
import configureStore from './stores';

require('es6-object-assign').polyfill();
const Adal = require('./adal/adal-request');

// process token callback from OAuth provider
Adal.processAdalCallback();


const store = configureStore({authInfo: {}, locale: detectBrowserLocale()});

if (window === window.parent) {
  ReactDOM.render(
    <Provider store={store}>
      <IntlContainer>
        <AppContainer>
          <Router history={browserHistory}>
            <Route component={App}>
              <Route path="/" component={HomeContainer} />
              <Route path="/ideas" component={IdeaContainer}>
                <Route path="/ideas(/:ideaType)" component={IdeaContainer}/>
              </Route>
              <Route path="/browse-ideas" component={BrowseIdeasContainer}>
                <Route path="/browse-ideas(/:ideaType)" component={BrowseIdeasContainer}/>
              </Route>
              <Route path="/manage-ideas" component={MyIdeasContainer}>
                <Route path="/manage-ideas(/:ideaType)" component={MyIdeasContainer}/>
              </Route>

              <Route path="/process-initiative/:ideaId" component={ProcessInitiativeContainer} />
              <Route path="/process-cip/:ideaId" component={ProcessCIPContainer} />
              <Route path="/users" component={UsersContainer} />
              <Route path="/user(/:userId)" component={UserEditContainer} />
              <Route path="/cipGroups" component={CipGroupsContainer} />
              <Route path="/cipGroup(/:groupId)" component={EditCipGroupContainer} />
              <Route path="/initiative-types(/:typeId)" component={InitiativeTypesContainer} />
            </Route>
            <Route path="/signout" component={SignOutPage} />
            <Route path="/error" component={ErrorContainer} />

            <Route path="*" component={My404Component} />
          </Router>
        </AppContainer></IntlContainer>
    </Provider>,
    document.getElementById('app')
  );
}

if (module.hot) {
  module.hot.accept('./containers/App', () => {
    const NextApp = require('./containers/App').default; // eslint-disable-line global-require
    if (window === window.parent) {
      ReactDOM.render(
        <Provider store={store}>
          <IntlContainer>
            <AppContainer>
              <Router history={browserHistory}>
                <Route component={NextApp}>
                  <Route path="/" component={HomeContainer} />
                  <Route path="/ideas" component={IdeaContainer}>
                    <Route path="/ideas(/:ideaType)" component={IdeaContainer} />
                  </Route>
                  <Route path="/browse-ideas" component={BrowseIdeasContainer}>
                    <Route path="/browse-ideas(/:ideaType)" component={BrowseIdeasContainer} />
                  </Route>
                  <Route path="/manage-ideas" component={MyIdeasContainer}>
                    <Route path="/manage-ideas(/:ideaType)" component={MyIdeasContainer}/>
                  </Route>

                  <Route path="/process-initiative/:ideaId" component={ProcessInitiativeContainer} />
                  <Route path="/process-cip/:ideaId" component={ProcessCIPContainer} />
                  <Route path="/users" component={UsersContainer} />
                  <Route path="/user(/:userId)" component={UserEditContainer} />
                  <Route path="/cipGroups" component={CipGroupsContainer} />
                  <Route path="/cipGroup(/:groupId)" component={EditCipGroupContainer} />
                  <Route path="/initiative-types(/:typeId)" component={InitiativeTypesContainer} />
                </Route>
                <Route path="/signout" component={SignOutPage} />
                <Route path="*" component={My404Component} />
                <Route path="/error" component={ErrorContainer} />
              </Router>

            </AppContainer>
          </IntlContainer>
        </Provider>,
        document.getElementById('app')
      );
    }
  });
}



// WEBPACK FOOTER //
// ./client.js